import React, { useContext, useState } from "react"
import CLASSES from "../data/champion/classes.json"
import ELEMENTS from "../data/champion/elements.json"
import LINEAGES from "../data/champion/lineages.json"
import SUBTYPES from "../data/champion/subtypes.json"

const classOpts = CLASSES
const elementOpts = ELEMENTS
const lineageOpts = LINEAGES
const subtypeOpts = SUBTYPES

const ChampionContext = React.createContext(null)

export const ChampionContextProvider = ({ children }) => {
  const [hideAlts, setHideAlts] = useState(true)
  const [elements, setElements] = useState([])
  const [lineages, setLineages] = useState([])
  const [classes, setClasses] = useState([])
  const [subtypes, setSubtypes] = useState([])
  const [focus, setFocus] = useState(null)
  const [search, setSearch] = useState("")

  function handleClear() {
    setHideAlts(true)
    setElements([])
    setLineages([])
    setClasses([])
    setSubtypes([])
    setFocus(null)
    setSearch("")
  }

  const clearDisabled =
    hideAlts &&
    !elements.length &&
    !lineages.length &&
    !classes.length &&
    !subtypes.length &&
    !focus

  // let lines = LINES

  // if (hideAlts) {
  //   lines = lines.filter((line) => {
  //     return line.every((card) => !card.computed.alternative)
  //   })
  // }
  // if (elements.length) {
  //   lines = lines.filter((line) => {
  //     return elements.every((element) =>
  //       line.some((card) => card.element === element)
  //     )
  //   })
  // }
  // if (lineages.length) {
  //   lines = lines.filter((line) => {
  //     return lineages.every((lineage) =>
  //       line.some((card) => card.computed.lineage === lineage)
  //     )
  //   })
  // }
  // if (classes.length) {
  //   lines = lines.filter((line) => {
  //     return classes.every((classType) =>
  //       line.some((card) => card.classes.includes(classType))
  //     )
  //   })
  // }
  // if (subtypes.length) {
  //   lines = lines.filter((line) => {
  //     return subtypes.every((subtype) =>
  //       line.some((card) => card.subtypes.includes(subtype))
  //     )
  //   })
  // }
  // if (search) {
  //   const text = search.toLowerCase()
  //   lines = lines.filter((line) => {
  //     return line.some((c) => {
  //       // console.log(c.computed.name)
  //       // console.log(c.computed.rawEffect)
  //       return Boolean(
  //         c.computed.name.includes(text) || c.computed.rawEffect?.includes(text)
  //       )
  //     })
  //   })
  // }

  const value = {
    search,
    setSearch,

    hideAlts,
    setHideAlts,
    elements,
    setElements,
    lineages,
    setLineages,
    classes,
    setClasses,
    subtypes,
    setSubtypes,

    clearDisabled,
    handleClear,

    classOpts,
    elementOpts,
    lineageOpts,
    subtypeOpts,

    focus,
    setFocus,
    // lines,
  }

  return (
    <ChampionContext.Provider value={value}>
      {children}
    </ChampionContext.Provider>
  )
}

export const useChampionContext = () => {
  const value = useContext(ChampionContext)
  if (value === null) {
    throw new Error("Called useChampionContext() outside of provider")
  }
  return value
}
